"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_helmet_async_1 = require("react-helmet-async");
var BaseProvider_1 = require("@gdp/react-app/lib/platforms/BaseProvider");
var ClientHelmetProvider = /** @class */ (function (_super) {
    tslib_1.__extends(ClientHelmetProvider, _super);
    function ClientHelmetProvider() {
        return _super.call(this, {}) || this;
    }
    ClientHelmetProvider.prototype.component = function (children) {
        return React.createElement(react_helmet_async_1.HelmetProvider, { context: this.provider }, children);
    };
    return ClientHelmetProvider;
}(BaseProvider_1.BaseProvider));
exports.ClientHelmetProvider = ClientHelmetProvider;
//# sourceMappingURL=ClientHelmetProvider.js.map